import { Module } from '@/interfaces/module';
import { EntityResource } from './entity.resource';
import { ModuleFilterVariables } from './queryVariables/filters/filters';

/**
 * Resource modułów
 *
 * @export
 * @class ModuleResource
 * @extends {EntityResource<Module>}
 */
export class ModuleResource extends EntityResource<Module> {
  public getFields = {
    id: true,
    name: true,
    path: true,
    active: true
  };

  public listFields = {
    id: true,
    name: true
  };

  protected listVariables = ModuleFilterVariables;

  constructor() {
    super({
      entityName: 'module'
    });
  }
}

export const moduleResource = new ModuleResource();
